import { SALES_API_BASE_URL } from "app/pages/sales-intelligence/constants/api";
import type { GetRequestOptions, IFetchService, PostConfigObject } from "app/services/fetchService";

import type {
    CompanyInformationQuota,
    CrmEnrichmentQuotaDto,
    DataCreditsContactsCost,
    DataCreditsOperationCost,
    DataCreditsStateDto,
    QuotaOperationState,
} from "../../types";

import type { IQuotaApiService } from "./types";

const createQuotaApiService = (fetchService: Readonly<IFetchService>): IQuotaApiService => {
    return {
        fetchCompaniesQuota(options?: Readonly<GetRequestOptions>): Promise<CompanyInformationQuota> {
            return fetchService.get("/sales-api/company-quota", undefined, options);
        },

        /* Endpoints for packages v < 4 */
        fetchExcelQuota(options?: Readonly<GetRequestOptions>): Promise<QuotaOperationState> {
            return fetchService.get("/sales-api/export-quota", undefined, options);
        },

        fetchContactsQuota(options?: Readonly<GetRequestOptions>): Promise<QuotaOperationState> {
            return fetchService.get("/sales-api/contacts/quota", undefined, options);
        },

        fetchCrmEnrichmentQuota(options?: Readonly<GetRequestOptions>): Promise<CrmEnrichmentQuotaDto> {
            return fetchService.get("/sales-api/crm-enrichment-quota", undefined, options);
        },

        /* Endpoints for packages v >= 4 */
        fetchDataCreditsState(options?: Readonly<GetRequestOptions>): Promise<DataCreditsStateDto> {
            return fetchService.get(`${SALES_API_BASE_URL}/data-credits/state`, undefined, options);
        },

        fetchStaticContactsDataCreditsCosts(options?: Readonly<GetRequestOptions>): Promise<DataCreditsContactsCost> {
            return fetchService.get("/sales-api/data-credits/contacts", undefined, options);
        },

        fetchStaticLeadsDataCreditsCosts(options?: Readonly<GetRequestOptions>): Promise<DataCreditsOperationCost> {
            return fetchService.get("/sales-api/data-credits/leads", undefined, options);
        },

        notifyDataCreditsAdmin(options?: Readonly<PostConfigObject>): Promise<void> {
            return fetchService.post("/sales-api/data-credits/notify-admin", undefined, options);
        },
    };
};

export default createQuotaApiService;
